import BzbsApi from '@/core/Http/BzbsApi';

export default {
    apiGetConfig: function (url, fileName) {
        var fullURL = `${url}/${fileName}`;
        // console.log(fullURL)
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGetBlob(fullURL).subscribe({
                next: (res) => {
                    // console.log(res)
                    let blob = res?.data ?? null
                    // console.log(blob)
                    resolve(blob)
                },
                error: (err) => {
                    reject(err)
                }
            })
        });
    }
}
